import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { TwitterButton, LinkedInButton, EmailButton } from 'react-social'
import config from 'config'
import {
  Link,
  LinkIcon,
  SrOnly
} from '../'

import Styles from './PlanScorecardHeaderShare.css'

@CSSModules(Styles, {allowMultiple: true})
export default class PlanScorecardHeaderShare extends Component {
  static propTypes = {
    planId: PropTypes.string.isRequired,
    planName: PropTypes.string.isRequired,
    companyTwitterHandle: PropTypes.string.isRequired,
    companyTicker: PropTypes.string.isRequired
  }
  constructor(props){
    super(props)
    this.state = {
      planId: props.planId,
      planName: props.planName,
      companyTwitterHandle: props.companyTwitterHandle,
      companyTicker: props.companyTicker
    }
  }

  render() {
    const { planId, planName, companyTwitterHandle, companyTicker } = this.state
    //

    const emailSubject = 'Apple\'s retirement plan'
    let emailText = `See how ${planName} is rated on fossil fuel investments and six other environmental and social sustainability issues.`
    const tweetText = `See how @${companyTwitterHandle}'s retirement plan is rated on fossil fuel investments and six other environmental and social sustainability issues. $${companyTicker} #ESG via @AsYouSow`
    const url = config.domain + config.routes.plans + '/' + planId + '?vshare=1'
    emailText = emailText + ' ' + url

    return (
      <div styleName='pshs-wrap'>

        <div styleName='take-action-share'>
          <div styleName='take-action-label'>
            <h2>
              Share
            </h2>
          </div>
          <div styleName='take-action-icons'>
            <div>
              <EmailButton
                title={emailText}
                message={emailSubject}
                url={emailText}
                element='a'
              >
                <SrOnly>
                  Email
                </SrOnly>
                <div>
                  <LinkIcon nospace faclass='fa-envelope'/>
                </div>
              </EmailButton>
            </div>
            <div>
              <Link
                to={'https://www.facebook.com/sharer/sharer.php?u='+url}
                title={emailText}
              >
                <SrOnly>
                  Facebook
                </SrOnly>
                <div>
                  <LinkIcon nospace faclass='fa-facebook-square'/>
                </div>
              </Link>
            </div>
            <div>
              <TwitterButton
                title={tweetText + ' ' + url}
                message={tweetText}
                url={url}
                element='a'
              >
                <SrOnly>
                  Twitter
                </SrOnly>
                <div>
                  <LinkIcon nospace faclass='fa-twitter-square'/>
                </div>
              </TwitterButton>
            </div>
            <div
              title='Share via LinkedIn'
            >
              <LinkedInButton
                title={emailText}
                url={url}
                element='a'
              >
                <SrOnly>
                  LinkedIn
                </SrOnly>
                <div>
                  <LinkIcon nospace faclass='fa-linkedin-square'/>
                </div>
              </LinkedInButton>
            </div>
          </div>
        </div>

      </div>
    )
  }
}